import baseRoute from '../baseRoute';

export default `${baseRoute}/workSummary` as const;
